"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListHeader = void 0;
var React = require("react");
var DidYouMean_1 = require("Views/Partials/Components/DidYouMean");
var index_1 = require("../../index");
var FilterableListTabs_1 = require("./FilterableListTabs");
var FilterableListHeader = function (_a) {
    var query = _a.query, typeFiltersList = _a.typeFiltersList, typeFilterAlias = _a.typeFilterAlias, onChangeFilter = _a.onChangeFilter, selectedFiltersQuery = _a.selectedFiltersQuery, allResultsCount = _a.allResultsCount, allResultsLabel = _a.allResultsLabel, isTitleHidden = _a.isTitleHidden, suggestions = _a.suggestions, setIsContentLoading = _a.setIsContentLoading;
    var onTabSwitch = React.useCallback(function (value) { return onChangeFilter(typeFilterAlias, value); }, [onChangeFilter, typeFilterAlias]);
    var searchHeading = React.useMemo(function () {
        return isTitleHidden(query) ? (React.createElement("div", { className: "empty-page-heading-placeholder" })) : (React.createElement("h1", { className: "page-heading text-primary block font-bold" },
            index_1.PageContext.title,
            " '",
            query,
            "'"));
    }, [isTitleHidden, query]);
    return (React.createElement("div", { className: "filterable-list__header", tabIndex: -1 },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "page-heading-wrapper" },
                searchHeading,
                React.createElement(DidYouMean_1.DidYouMean, { suggestions: suggestions, selectedFiltersQueryString: selectedFiltersQuery })),
            React.createElement(FilterableListTabs_1.FilterableListTabs, { typeFiltersList: typeFiltersList, onTabSwitch: onTabSwitch, selectedFiltersQuery: selectedFiltersQuery, allResultsCount: allResultsCount, allResultsLabel: allResultsLabel, setIsContentLoading: setIsContentLoading }))));
};
exports.FilterableListHeader = FilterableListHeader;
